import React from "react";
import {
  HiOutlineCurrencyDollar,
  HiOutlineEye,
  HiOutlineShieldCheck,
  HiOutlineDocumentText,
  HiOutlineBadgeCheck,
  HiOutlineGlobeAlt,
} from "react-icons/hi";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import "./style.css";

const ADVANTAGE_IMAGE = "/images/advantage-global-market.jpg";

const trim = (str) => (str || "").trim();

const ADVANTAGE_ICONS = [
  HiOutlineCurrencyDollar,
  HiOutlineEye,
  HiOutlineShieldCheck,
  HiOutlineDocumentText,
];

const FLOAT_CHIPS = [
  { Icon: HiOutlineShieldCheck, text: "Secure transactions" },
  { Icon: HiOutlineGlobeAlt, text: "Trusted worldwide" },
  { Icon: HiOutlineBadgeCheck, text: "Verified dealers" },
];

function What() {
  const { feedback } = useContext(FeedbackContext);
  const home_page = feedback.home_page;

  const items = [
    {
      title: home_page.what_expect_list_heading1,
      desc: home_page.what_expect_list_heading1_desp,
    },
    {
      title: home_page.what_expect_list_heading2,
      desc: home_page.what_expect_list_heading2_desp,
    },
    {
      title: home_page.what_expect_list_heading3,
      desc: home_page.what_expect_list_heading3_desp,
    },
    {
      title: home_page.what_expect_list_heading4,
      desc: home_page.what_expect_list_heading4_desp,
    },
  ];

  return (
    <>
      <header className="pi-section-head">
        <p className="pi-label">Why us</p>
        <h2>{trim(home_page.what_expect_heading)}</h2>
        <p>{trim(home_page.what_expect_desp)}</p>
      </header>

      <div className="pi-advantage__layout">
        <div className="pi-advantage__visual">
          <img
            src={ADVANTAGE_IMAGE}
            alt="New and used vehicles on AutoTrade Port"
            loading="lazy"
            decoding="async"
          />
          <div className="pi-advantage__float">
            {FLOAT_CHIPS.map(({ Icon, text }) => (
              <span key={text}>
                <Icon size={14} aria-hidden />
                {text}
              </span>
            ))}
          </div>
        </div>

        <div className="pi-advantage__list">
          {items.map((item, i) => {
            const Icon = ADVANTAGE_ICONS[i] || HiOutlineShieldCheck;
            return (
              <article key={item.title} className="pi-advantage__item">
                <div className="pi-advantage__icon">
                  <Icon aria-hidden />
                </div>
                <div>
                  <h3>{trim(item.title)}</h3>
                  <p>{trim(item.desc)}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default What;
